<a (click)="filterWorks('new')" [routerLink]="[currentLang,'work']" [queryParams]="{ filter: 'new' }" [class.active]="currentFilter=='new'">
	{{"MENU.WORK.NEW" | translate }}</a>
<ng-container *ngIf="filterMenu.length">
	<ng-container *ngFor="let filterItem of filterMenu">
		<a (click)="filterWorks(filterItem.slug)" [routerLink]="[currentLang,'work']" [queryParams]="{ filter: filterItem.slug }"
		 [class.active]="currentFilter==filterItem.slug">
			{{ filterItem.name }}
		</a>
	</ng-container>
</ng-container>
<a (click)="filterWorks('legacy')" [routerLink]="[currentLang,'work']" [queryParams]="{ filter: 'legacy' }"
 [class.active]="currentFilter=='legacy'">{{ "MENU.WORK.LEGACY" | translate }}</a>
